import React from "react";
import { Navigate } from "react-router-dom";
import { getUserData } from "../utils/localStorage";

const RequireRole = ({ roles, children }) => {
  const { userProfileRole } = getUserData();
  if (!roles.includes(userProfileRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default RequireRole;
